module.exports = __webpack_public_path__ + "img/179970.25d085d1.png";